import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ConsultationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    countryCode: "+91",
    enquiryType: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const { name, email, mobile, enquiryType } = formData;

    if (
      !name.trim() &&
      !email.trim() &&
      !mobile.trim() &&
      !enquiryType.trim()
    ) {
      toast.error("Please validate the form.");
      return false;
    }

    let isValid = true;

    if (!name.trim()) {
      toast.error("Name is required.");
      isValid = false;
    }

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address.");
      isValid = false;
    }

    if (!/^\+\d{1,4}\d{6,14}$/.test(`${formData.countryCode}${mobile}`)) {
      toast.error("Please enter a valid phone number with country code.");
      isValid = false;
    }

    if (!enquiryType.trim()) {
      toast.error("Enquiry type is required.");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const processingToastId = toast.info("Processing your request...", {
      autoClose: false,
    });

    // Simulate form submission delay
    await new Promise((resolve) => setTimeout(resolve, 2000));

    toast.dismiss(processingToastId);
    toast.success("Form submitted successfully!");

    // Reset form data
    setFormData({
      name: "",
      email: "",
      mobile: "",
      countryCode: "+91",
      enquiryType: "",
      message: "",
    });
  };

  const countryCodes = [
    { label: "IN (+91)", value: "+91" },
    { label: "US (+1)", value: "+1" },
    { label: "GB (+44)", value: "+44" },
    { label: "AU (+61)", value: "+61" },
    { label: "CA (+1)", value: "+1" },
    { label: "FR (+33)", value: "+33" },
    { label: "DE (+49)", value: "+49" },
    { label: "JP (+81)", value: "+81" },
    { label: "CN (+86)", value: "+86" },
    { label: "RU (+7)", value: "+7" },
    { label: "BR (+55)", value: "+55" },
    { label: "ZA (+27)", value: "+27" },
    { label: "NG (+234)", value: "+234" },
    { label: "KE (+254)", value: "+254" },
    { label: "MX (+52)", value: "+52" },
    { label: "SG (+65)", value: "+65" },
    { label: "AE (+971)", value: "+971" },
  ];

  const enquiryTypes = [
    "General Inquiry",
    "Sales",
    "Support",
    "Feedback",
    "Other",
  ];

  return (
    <div className="bg-[#EAF5FE] py-10 px-4">
      <div className="p-8 rounded-lg max-w-4xl mx-auto text-center bg-[#EAF5FE]">
        <h2 className="text-3xl font-bold mb-8 text-black">
          Get Zero-Cost Salesforce Consultation
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Name and Email */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name"
              className="p-3 rounded-md focus:outline-none shadow-md text-black"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              className="p-3 rounded-md focus:outline-none shadow-md text-black"
            />
          </div>

          {/* Mobile Number and Enquiry */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center rounded-md bg-white shadow-md">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                className="p-1 border-r bg-white text-gray-500 opacity-60 focus:outline-none appearance-none"
                style={{
                  padding: "0px 12px",
                  backgroundImage:
                    "url('data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjY2NjY2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNC42NTYgNi44MzJhMSAxIDAgMDEuMzEzLjI1NWwzLjI5NCAyLjU2MyAzLjI5Ni0yLjU2NGEuOTk3Ljk5NyAwIDAxMS4zNTQuMjc1Yy4xODQuMjMuMjg0LjUxLjI4NS44MjMgMCAuNDUzLS4yNi44NDItLjY1OC45NTdsLTQuMDAxIDMuMTI0YS45OTguOTk4IDAgMDEtMS4zNzggMGwtNC4wMDEtMy4xMjNhLjk5OS45OTkgMCAwMS42NS0xLjgxNnoiLz48L3N2Zz4=')", // Custom arrow
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 12px center",
                  backgroundSize: "12px",
                }}
              >
                {countryCodes.map((code) => (
                  <option key={code.value} value={code.value}>
                    {code.label}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Mobile Number"
                className="flex-1 p-3 focus:outline-none"
              />
            </div>
            <select
              name="enquiryType"
              value={formData.enquiryType}
              onChange={handleChange}
              className={`p-3 rounded-md focus:outline-none shadow-md appearance-none ${
                formData.enquiryType === "" ? "text-[#999999]" : "text-black"
              }`}
              style={{
                backgroundImage:
                  "url('data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjNjY2NjY2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNNC42NTYgNi44MzJhMSAxIDAgMDEuMzEzLjI1NWwzLjI5NCAyLjU2MyAzLjI5Ni0yLjU2NGEuOTk3Ljk5NyAwIDAxMS4zNTQuMjc1Yy4xODQuMjMuMjg0LjUxLjI4NS44MjMgMCAuNDUzLS4yNi44NDItLjY1OC45NTdsLTQuMDAxIDMuMTI0YS45OTguOTk4IDAgMDEtMS4zNzggMGwtNC4wMDEtMy4xMjNhLjk5OS45OTkgMCAwMS42NS0xLjgxNnoiLz48L3N2Zz4=')", // Custom arrow
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                backgroundSize: "12px",
              }}
            >
              <option value="" disabled>
                Select Type of Enquiry
              </option>
              {enquiryTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          {/* Message */}
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            className="w-full p-3 rounded-md focus:outline-none shadow-md"
            rows="4"
          ></textarea>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-[200px] max-w-xs mx-auto py-3 bg-white text-[#999999] rounded-full font-semibold hover:bg-[#007bff] shadow-lg hover:text-white transition"
          >
            Submit
          </button>
        </form>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        closeOnClick
      />
    </div>
  );
};

export default ConsultationForm;
